import { render, staticRenderFns } from "./RequestStatistic.vue?vue&type=template&id=beb8292e&"
import script from "./RequestStatistic.vue?vue&type=script&lang=js&"
export * from "./RequestStatistic.vue?vue&type=script&lang=js&"
import style0 from "./RequestStatistic.vue?vue&type=style&index=0&id=beb8292e&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports